<div class="tw-relative tw-flex tw-w-full tw-overflow-hidden tw-rounded-2 tw-border tw-border-solid tw-border-orange-200 tw-bg-orange-50">
  <div class="tw-relative tw-w-32 tw-shrink-0 tw-overflow-hidden tw-bg-gray-100 tw-p-2">
    @if (image()) {
      <img class="tw-h-full tw-w-full tw-object-contain tw-p-2" [src]="image()" alt="free product" />
    }
    <!-- Gift corner badge: CSS triangle + the exported glyph (Figma 29697:22255). -->
    <div class="tw-absolute tw-left-0 tw-top-0 tw-h-9 tw-w-8 tw-bg-orange-400 tw-clip-corner-tl"></div>
    <img class="tw-absolute tw-left-1 tw-top-1 tw-h-2.5 tw-w-2.5" src="/assets/images/aov-gift-icon.svg" alt="" />
  </div>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-center tw-gap-1 tw-px-4">
    <p class="tw-text-200 tw-font-lexend tw-font-medium tw-text-gray-800">{{ title() }}</p>
    <p class="tw-text-100 tw-font-body tw-font-medium tw-text-gray-400">{{ quantityLabel() }}</p>
    <div class="tw-flex tw-items-center tw-gap-1">
      @if (mrp()) {
        <del class="tw-text-200 tw-font-lexend tw-font-medium tw-text-gray-500">₹{{ mrp() }}</del>
      }
      <span class="tw-text-300 tw-font-lexend tw-font-bold tw-uppercase tw-text-orange-500" i18n="@@free">free</span>
    </div>
  </div>
</div>
